import React, { useEffect, useState } from 'react';
import { Typography, Grid, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useCartContext } from 'context/CartContext';
import ReDialog from '../../components/ReDialog';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import { useAuthContext } from 'context/AuthContext';
import QrCodeDialog from './QrCodeDialog';
import { useMiniappConfirm } from 'state/useMiniappConfirm';
import useRxdbStoreLog from 'hooks/useRxdbStoreLog';
import useRxdbMiniappReq from 'hooks/useRxdbMiniappReq';
import { useMiniappReq } from 'state/useMiniappReq';
import { useGeneralContext } from 'context/GeneralContext';
import { ObjectId } from 'bson';
import { insertMiniappStoreLogUtil } from 'hooks/useInsertMiniappStoreLog';

const useStyles = makeStyles({
  titleStyle: {
    paddingBottom: 0,
  },
  customButton: {
    marginTop: 20,
    fontWeight: 'bold',
    width: '80%',
    left: `calc(50% - 80%/2)`,
  },
  button: {
    width: '200px',
    fontWeight: 'bold',
  },
  confirmText: {
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
});

const ConfirmDialog = ({
  titleDialog,
  messageDialog,
  closeModal,
  confirmTransaction,
  closeQRcode,
  setting,
  getColorApp,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [confirmed, setConfirmed] = useState(false);
  const [isButtonClick, setButtonClick] = useState(false);
  const [openQRcode, setOpenQRcode] = useState({ visible: false, data: null });
  const { clearCart } = useCartContext();
  const { toastError } = useGeneralContext();
  const { getOutletId, hitAPIEC2 } = useAuthContext();
  const [stateTransParameter, setstateTransParameter] = useState('');
  const [ , subscribeConfirm ] = useRxdbStoreLog();
  const { getMiniappConfirm, updateMiniappConfirm, updateMiniappConfirmId } = useMiniappConfirm((state) => ({
    getMiniappConfirm: state.getMiniappConfirm,
    updateMiniappConfirm: state.updateMiniappConfirm,
    updateMiniappConfirmId: state.updateMiniappConfirmId,
  }));
  const [ subscribeMiniappReq ] = useRxdbMiniappReq();
  const { getMiniappReq, updateMiniappReq, updateMiniappReqId } = useMiniappReq((state) => ({
    getMiniappReq: state.getMiniappReq,
    updateMiniappReq: state.updateMiniappReq,
    updateMiniappReqId: state.updateMiniappReqId,
  }));

  const handleCloseQRcode = () => {
    setOpenQRcode({ visible: false, data: null });
    closeQRcode();
  };

  const handleClickButton = async () => {
    updateMiniappConfirm(false);
    updateMiniappReq(null);
    setButtonClick(true);
    const id = new ObjectId().toString();
    updateMiniappConfirmId(id);
    try {
      await insertMiniappStoreLogUtil(hitAPIEC2, getOutletId(), id);
    } catch (error) {
      console.error('Error inserting miniapp storelog:', error);
    }
    subscribeConfirm();
  }

  const nextTransaction = async () => {
    updateMiniappReqId('');
    updateMiniappReq(null);
    setButtonClick(true);
    const reqId = new ObjectId().toString();
    updateMiniappReqId(reqId);
    await subscribeMiniappReq();
    let confirmTrans = await confirmTransaction();
    const transaction = JSON.parse(confirmTrans);
    if (transaction.status === 'success') {
      setstateTransParameter(transaction?.parameter);
    } else {
      setButtonClick(false);
      closeModal();
    }
  }

  useEffect(() => {
    if (getMiniappConfirm()) {
      setTimeout(() => {
        nextTransaction();
      }, 200);
    }
    // eslint-disable-next-line
  }, [getMiniappConfirm()]);

  useEffect(() => {
    if (getMiniappReq()) {
      if (getMiniappReq() === 'updated') { 
        setTimeout(() => { 
          setConfirmed(true); 
          setOpenQRcode({
            visible: true,
            data: stateTransParameter,
          });
          clearCart();
        }, 200);
      } else {
          closeModal();
          setButtonClick(false);
          toastError(t('errorMessage'));
        } 
    }
    // eslint-disable-next-line
  }, [getMiniappReq()]);


  return (
    <>
      <ReDialog
        title={titleDialog || t('confirmOrder').toUpperCase()}
        customTitleStyle={{ backgroundColor: getColorApp()?.backgroundColor, color: getColorApp()?.primaryFontColor }}
        contentStyle={{ backgroundColor: getColorApp()?.backgroundColor, color: getColorApp()?.primaryFontColor }}
        content={
          <Grid container direction="column" spacing={8}>
            <Grid item>
              <Typography className={classes.confirmText} style={{ color: getColorApp()?.primaryFontColor }}>
                {messageDialog !== undefined && messageDialog !== ''
                  ? messageDialog
                  : setting &&
                    setting.confirmOrderText !== undefined &&
                    setting.confirmOrderText !== ''
                    ? setting.confirmOrderText
                    : t('confirmOrderMessage')}
              </Typography>
            </Grid>
            {isButtonClick ? (
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center">
                <CircularProgress style={{ color: getColorApp()?.secondaryThemeColor }} size={50} />
              </Grid>
            ) : (
              <Grid container direction="row">
                <Grid item style={{ width: '50%' }}>
                  <Button
                    onClick={closeModal}
                    className={classes.customButton}
                    size="large"
                    type="cancel"
                    title={`${t('cancel')}`}
                  />
                </Grid>
                <Grid item style={{ width: '50%' }}>
                  <Button
                    onClick={handleClickButton}

                    className={classes.customButton}
                    size="large"
                    type="confirm"
                    title={`${t('confirm')}`}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        }
      />
      {confirmed && openQRcode.visible && (
        <QrCodeDialog
          closeModal={() => handleCloseQRcode()}
          data={openQRcode.data}
        />
      )}
    </>
  );
};

export default ConfirmDialog;
